module.exports = __webpack_public_path__ + "static/b1_large-7785047b7b1a9c3e30d2e54dddb15b2a.jpg";